import { render, staticRenderFns } from "./VippsLoginButton.vue?vue&type=template&id=f377b220&"
import script from "./VippsLoginButton.vue?vue&type=script&lang=js&"
export * from "./VippsLoginButton.vue?vue&type=script&lang=js&"
import style0 from "./VippsLoginButton.vue?vue&type=style&index=0&id=f377b220&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports